import { render, staticRenderFns } from "./selectUser.vue?vue&type=template&id=23a8aeac&scoped=true&"
import script from "./selectUser.vue?vue&type=script&lang=js&"
export * from "./selectUser.vue?vue&type=script&lang=js&"
import style0 from "./selectUser.vue?vue&type=style&index=0&id=23a8aeac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8aeac",
  null
  
)

export default component.exports